export const ERROR_MESSAGE_HEIGHT = 14;
export const TEXT_SHRINK_WIDTH = 22;
